import { t } from '../../i18n/i18n';
import './ChartLegend.scss';

/**
 * Small colour-swatch + label legend, reused by CandlestickChart. Purely presentational — the consumer positions it
 * (e.g. absolute bottom-left over the chart) via `className`.
 *
 * @param {{
 *   items: { color: string, label: string }[],
 *   className?: string,
 * }} props
 */
export default function ChartLegend({ items = [], className = '' }) {
  if (!items.length) return null;

  return (
    <ul className={`ac-chart-legend ${className}`.trim()}>
      {items.map((item) => (
        <li key={item.label} className="ac-chart-legend__item">
          <span className="ac-chart-legend__swatch" style={{ backgroundColor: item.color }} />
          <span className="ac-chart-legend__label">{t(item.label)}</span>
        </li>
      ))}
    </ul>
  );
}
